module.exports = __webpack_public_path__ + "assets/img/430197c46cc36875cc023226d347d23a.png";